import { Divider, Stack, styled, Typography } from '@mui/material';
import { memo, useCallback } from 'react';
import { Scrollbar } from '@dfl/mui-admin-layout';
import { IStockWarehouses } from '../../interfaces/IProduct';
import { LongText } from '@dfl/mui-react-common';
import { useNavigate } from 'react-router';

const Content = styled(Stack)<{ bg: 'error' | 'primary' }>(({ theme, bg }) => ({
  height: 50,
  position: 'relative',
  padding: '8px 16px',
  gap: 8,
  flexDirection: 'row',
  alignItems: 'center',
  ':hover': {
    backgroundColor: theme.palette.background.default,
    cursor: 'pointer',
  },

  ':before': {
    content: '""',
    position: 'absolute',
    top: 0,
    left: 0,
    width: 8,
    height: '100%',
    borderRadius: 5,
    backgroundColor: theme.palette[bg].main,
  },
}));

const WarehouseStockList = ({ warehouses }: { warehouses: IStockWarehouses[] }) => {
  const navigate = useNavigate();

  const handleClick = useCallback((warehouse: string) => {
    navigate(`/inventory/warehouses/${warehouse}/general`);
  }, [navigate]);

  return (
    <Scrollbar
      sx={{
        maxHeight: 300,
        '& .simplebar-content': {
          maxHeight: 300,
        },
      }}
    >
      <Stack flex={1} divider={<Divider flexItem orientation='horizontal' />}>
        {warehouses?.map((warehouse: IStockWarehouses) => (
          <Content
            onClick={() => { handleClick(warehouse?.warehouse); }}
            bg={(warehouse?.stock === 0) ? 'error' : 'primary'}
            key={warehouse?.warehouse}
          >
            <LongText lineClamp={1} text={warehouse?.warehouseName} />
            <Typography sx={{ fontWeight: 600 }}>({warehouse?.stock})</Typography>
          </Content>
        ))}
      </Stack>
    </Scrollbar>
  );
};

export default memo(WarehouseStockList);
